import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import SeoContentSection from './components/SeoContentSection';
import ArticlesSection from './components/ArticlesSection';
import FaqSection from './components/FaqSection';
import CtaBanner from './components/CtaBanner';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://itaobuyspread.mom';

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Itaobuy Spread',
    url: siteUrl,
    description: 'Itaobuy Spreadsheet Italiano: trova prodotti verificati, QC foto e migliori offerte. Guida completa in italiano.',
    inLanguage: 'it',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Itaobuy Spread',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
    description: 'Itaobuy Spreadsheet Italiano: trova prodotti verificati, QC foto e migliori offerte. Guida completa in italiano.',
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureGrid />
        <SeoContentSection />
        <ArticlesSection />
        <FaqSection />
        <CtaBanner />
      </main>
      <Footer />
    </>
  );
}